export default "__VITE_ASSET__BrOFRsv3__"